import { Document, Packer, Paragraph, TextRun } from 'docx';

export function downloadDocx(text: string, filename = 'file.docx') {
    const doc = new Document({
        sections: [
            {
                children: [
                    new Paragraph({
                        children: [new TextRun(text)],
                    }),
                ],
            },
        ],
    });

    Packer.toBlob(doc).then((blob) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.click();
        URL.revokeObjectURL(link.href);
    });
}
